import { render, staticRenderFns } from "./PdfGenerator.vue?vue&type=template&id=bdfcb0a0&scoped=true"
import script from "./PdfGenerator.vue?vue&type=script&lang=js"
export * from "./PdfGenerator.vue?vue&type=script&lang=js"
import style0 from "./PdfGenerator.vue?vue&type=style&index=0&id=bdfcb0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfcb0a0",
  null
  
)

export default component.exports